<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 sales-order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("SALES_ORDERS.ADD_SALES_ORDER") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <sales-order-form
              :loading="loading"
              :salesOrderData="salesOrder"
              :formErrors="formErrors"
              @salesOrderSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultSalesOrder from "./defaultSalesOrder";
import SalesOrderForm from "./partials/SalesOrderForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    SalesOrderForm,
  },

  mixins: [alertLeave],

  data() {
    const salesOrder = cloneDeep(defaultSalesOrder);
    if (this.$currentUserIsLevelOrganization()) {
      salesOrder.organization = {
        type: "organizations",
        id: this.$currentUserOrganizationId(),
      };
    }
    return {
      salesOrder: salesOrder,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List SalesOrders" });
    },

    viewSalesOrder(salesOrder) {
      this.alertLeave = false;
      this.$router.push({
        name: "View SalesOrder",
        params: { id: salesOrder.id },
      });
    },

    async handleSubmit(salesOrder) {
      this.loading = true;
      const salesOrderData = cloneDeep(salesOrder);
      if (!salesOrderData.sourceWarehouse.id) {
        delete salesOrderData.sourceWarehouse;
      }
      try {
        await this.$store.dispatch("salesOrders/add", salesOrderData);
        this.$notify({
          type: "success",
          message: this.$t("SALES_ORDERS.SALES_ORDER_ADDED"),
        });
        const salesOrder = await this.$store.getters["salesOrders/salesOrder"];
        this.viewSalesOrder(salesOrder);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
